import InfoTooltip from 'src/legacy/components/Tooltip/InfoTooltip';

export { DescriptionTooltip } from './DescriptionTooltip';
export { TooltipWrapper } from './TooltipWrapper';
export { ExtensionTooltipTitle } from './ExtensionTooltipTitle';
export * from './NonDesktopActionTooltip';
export default InfoTooltip;
